import { Button } from 'components/buttons/Button/Button';
import HeaderNavigationCard from './HeaderNavigationCard';

const HeaderNavigationDropdown = ({ items, button }) => {
    return (
        <div className="navigation-item__dropdown">
            <div className="navigation-item__dropdown-items">
                {items.map(item => (
                    <HeaderNavigationCard key={item.link} item={item} />
                ))}
            </div>
            {button && (
                <div className="navigation-item__dropdown-button">
                    <Button href={button.link} type="learn-more-arrow white-text">
                        {button.name}
                    </Button>
                </div>
            )}
        </div>
    );
};

export default HeaderNavigationDropdown;
